(() => {
  const viewport = window.matchMedia('(max-width: 989px)');
  const selector = 'h1,h2,h3,h4,h5,h6,p,li,dt,dd,blockquote,figcaption,label,legend,summary,button,.card__heading,.accordion__title,.product__heading,.break';
  let timer;
  let marked = [];
  const update = () => {
    document.body.classList.add('pt-natural-wrap');
    document.querySelectorAll('a').forEach(link => {
      link.classList.toggle('pt-address-wrap', /^(https?:\/\/|www\.)/i.test(link.textContent.trim()));
    });
    marked.forEach(element => element.classList.remove('pt-needs-hyphenation'));
    marked = [];
    if (!viewport.matches) return;
    const candidates = Array.from(document.querySelectorAll(selector)).filter(element =>
      !element.closest('[hidden],[aria-hidden="true"],[contenteditable],.visually-hidden,.sr-only,script,style,pre,code') &&
      element.clientWidth > 0 &&
      element.getClientRects().length > 0
    );
    marked = candidates.filter(element => element.scrollWidth > element.clientWidth + 1);
    marked.forEach(element => element.classList.add('pt-needs-hyphenation'));
  };
  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(update, 100);
  };
  const start = () => {
    update();
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('toggle', schedule, true);
    document.addEventListener('transitionend', event => {
      if (event.target.matches('details,.menu-drawer,.drawer')) schedule();
    });
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    if (document.fonts) {
      document.fonts.ready.then(update);
      document.fonts.addEventListener('loadingdone', schedule);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
